export default "__VITE_ASSET__SfYibO$r__"